import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-4 py-12 text-center text-white/65" data-id="element-91" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-92" data-mp="3ggaovpzpm32t">
        <p className="font-serif text-2xl text-white" data-id="element-93" data-mp="3gh3qydnq44em">Therapeutic Tarot Guide™</p>
        <p className="mt-3 text-sm font-semibold text-white/80" data-id="element-94" data-mp="32pp4txyirn3c">
          The #1 self-guided therapeutic tarot reference library for global practitioners.
        </p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-95" data-mp="3ug3gdnj28nbu">
          Because a professional therapeutic practice deserves a real professional system.
        </p>
        <p className="mt-6 text-sm" data-id="element-96" data-mp="3lecaoioisghz">
          📧{' '}
          <a className="transition-colors duration-200 hover:text-amber" href="mailto:support@therapeutictarot.guide" data-id="element-97" data-mp="3ldkgncakmqtt">
            support@therapeutictarot.guide
          </a>{' '}
          <span className="mx-2 text-white/30" data-id="element-98" data-mp="29xvrce9uhfpu">·</span> 🌐 www.therapeutictarot.guide
        </p>
        <p className="mt-6 text-xs" data-id="element-99" data-mp="2ezl2rv0zbveg">© Therapeutic Tarot Guide™ 2026 — All rights reserved.</p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-100" data-mp="3la27uq37evt4">
          This product is a digital download for educational and professional reference purposes.
          This system does not replace professional medical, psychological, or spiritual advice. All
          content is protected by copyright.
        </p>
      </div>
    </footer>;
}